import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    // Remove key -- use as env variable
  apiKey: "AIzaSyDH691rgpb22KRcbtn68LSvab-ZtwpSlX0",
  authDomain: "woof-a0011.firebaseapp.com",
  projectId: "woof-a0011",
  storageBucket: "woof-a0011.appspot.com",
  messagingSenderId: "589257482631",
  appId: "1:589257482631:web:8d0de96a4447686b907322",
  measurementId: "G-RWFN414GPM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);